/* eslint-disable react-hooks/exhaustive-deps */
import { Switch } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const ProfileInfo = ({ provider, listProvider }) => {
  const navigate = useNavigate();

  // Handle navigation to EditProviderInfo with provider details
  const handleEdit = () => {
    navigate("/EditProviderInfo", { state: { provider } });
  };

  const [chatFetureEnabled, setChatFetureEnabled] = useState(false);
  const [disableProviderEnabled, setDisableProviderEnabled] = useState(false);

  useEffect(() => {
    if (provider?.provider_status) {
      setDisableProviderEnabled(
        provider?.provider_status === "enable" ? false : true
      );
    }
  }, [provider?.provider_status]);

  const toggleProviderStatus = async () => {
    const newStatus = disableProviderEnabled === false ? 2 : 1; // 1 = enable, 2 = disable

    try {
      await getApiCaller(
        `provider_status_change?provider_id=${provider.id}&status=${newStatus}`
      );
      setDisableProviderEnabled(newStatus === 1 ? false : true);
      toast.success(
        `Provider ${newStatus === 1 ? "enabled" : "disabled"} successfully!`
      );
    } catch (error) {
      toast.error("Failed to update provider status.");
    }
  };

  return (
    <>
      <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
        <div className="flex justify-between">
          <p className="text-[#284184] font-bold">Profile Info</p>
          <button
            className="text-[#E0A256] text-base flex items-center space-x-1"
            onClick={handleEdit}
          >
            <CiEdit size={20} />
            <span className="underline">Edit Provider Info</span>
          </button>
        </div>
      </div>

      <div className="border border-t-0 rounded-b-2xl px-4 pt-4 bg-white">
        <div className="flex sm:flex-row flex-col items-center space-x-4">
          <div className="rounded-xl bg-gray-200 flex items-center justify-center">
            <img
              src={
                provider?.profile_picture ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s"
              }
              alt={"profile"}
              className="w-24 h-24 rounded-xl"
            />
          </div>
          <div className="rounded-lg border-2 border-[#f04438] p-4 sm:min-w-[450px]">
            <div className="flex justify-between items-center">
              <p>Chat Features:</p>
              <div className="flex items-center gap-2">
                <p>Enable</p>
                <Switch
                  checked={chatFetureEnabled}
                  onChange={setChatFetureEnabled}
                  className="group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-[#284184]"
                >
                  <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
                </Switch>
                <p>Disable</p>
              </div>
            </div>
            <div className="flex justify-between items-center mt-4">
              <p>Disable This Provider:</p>
              <div className="flex items-center gap-2">
                <p>Enable</p>
                <Switch
                  checked={disableProviderEnabled}
                  onChange={() => toggleProviderStatus()}
                  className={`group inline-flex h-6 w-11 items-center rounded-full transition ${
                    disableProviderEnabled ? "bg-[#284184]" : "bg-gray-200"
                  }`}
                >
                  <span
                    className={`size-4 translate-x-1 rounded-full bg-white transition ${
                      disableProviderEnabled ? "translate-x-6" : ""
                    }`}
                  />
                </Switch>

                <p>Disable</p>
              </div>
            </div>
          </div>
        </div>

        {/* Personal Details */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">First Name</label>
            <div className="font-medium">{provider?.first_name || "N/A"}</div>
          </div>
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">Last Name</label>
            <div className="font-medium">{provider?.last_name || "N/A"}</div>
          </div>
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">Email Address</label>
            <div className="font-medium">{provider?.email || "N/A"}</div>
          </div>
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">Mobile Number</label>
            <div className="font-medium">
              {provider?.country_code + " " + provider?.number || "N/A"}
            </div>
          </div>
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">I am experienced in</label>
            <div className="font-medium">
              <ol className="list-disc pl-5">
                {provider?.experience_in &&
                  provider?.experience_in
                    ?.filter((filterData) => filterData?.is_selected)
                    ?.map((res, index) => {
                      return <li key={index}>{res.question}</li>;
                    })}
              </ol>
            </div>
          </div>
          <div className="pb-2 border-b-2">
            <label className="text-sm text-gray-500">About Provider</label>
            <div className="font-medium"></div>
          </div>

          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Service</label>
            <p className="text-base">{provider?.service_name || "N/A"}</p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">
              Foot Care Appointments till date
            </label>
            <p className="text-base">
              {provider?.appointment_till_date || "N/A"}{" "}
              {provider?.appointment_till_date && "+"}
            </p>
          </div>

          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Apt No</label>
            <p className="text-base">
              {provider?.billing_details.billing_apt_no || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Street</label>
            <p className="text-base">
              {provider?.billing_details.billing_street || "N/A"}
            </p>
          </div>

          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">City</label>
            <p className="text-base">
              {provider?.billing_details?.billing_city || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Province/State</label>
            <p className="text-base">
              {provider?.billing_details?.billing_state || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Postal Code</label>
            <p className="text-base">
              {provider?.billing_details?.billing_postal_code || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">
              Country Nursing License
            </label>
            <p className="text-base">
              {provider?.license_details?.license_country || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">
              State/Province for Nursing License
            </label>
            <p className="text-base">
              {provider?.license_details?.license_state || "N/A"}
            </p>
          </div>

          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">
              License/Registration No
            </label>
            <p className="text-base">
              {provider?.license_details?.license_no || "N/A"}
            </p>
          </div>
          <div className="space-y-2 pb-2 border-b-2">
            <label className="text-[#8B8D98] text-sm">Appointment Fee</label>
            <p className="text-base">${provider?.appointment_fee || "0"}</p>
          </div>
        </div>
        <br />
      </div>
    </>
  );
};

export default ProfileInfo;
